import React, { useState, useEffect } from 'react';
import { auth, db } from './firebase';
import './App.css';
import { collection, query, getDocs, addDoc, where } from '@firebase/firestore';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages'
import Tournaments from './pages/tournaments'
import AdminPage from './components/Admin';
import CreateTournament from './components/Admin/create_tournaments';
import CreateNewAssociation from './components/Admin/create_association';
import CreateNewGolfCourse from './components/Admin/create_golf_course'
import AdminLoginSignup from './components/Admin/login_signup';
import AdminUnverifiedPage from './components/Admin/unverified_page';
import TournamentDetailPage from './components/TournamentsPage/TournamentDetailPage';
import LoginSignup from './components/LoginSignup';
import ListTournaments from './components/Admin/list_tournaments';
import EditTournament from './components/Admin/edit_tournaments';
import TournamentsByUser from './components/Admin/tournaments_by_user';
import TournamentsByUserWindow from './components/Admin/tournaments_by_user_challenge';
import ListGolfCourses from './components/Admin/list_golf_courses';
import EditGolfCourse from './components/Admin/edit_golf_courses';

function App() {

    const [loading, setLoading] = useState(true)
    const [authenticated, setAuthenticated] = useState(false)
    const [adminAuthenticated, setAdminAuthenticated] = useState(false)
    const [adminVerified, setAdminVerified] = useState(false)

    useEffect(() => {
        setLoading(true)
        var authUnsubscribe = auth.onAuthStateChanged(async (user) => {
            setLoading(true)
            if (user) {
                // logged in
                console.log(user)
                setAuthenticated(true)
                // Check to see if admin user, and if so, if verified
                // get users from firestore, filter by userId
                console.log('Checking if user is admin...')
                setAdminAuthenticated(false)
                setAdminVerified(false)
                // query the users collection for the userId
                const usersRef = collection(db, 'users')
                const q = query(usersRef, where('userId', '==', user.uid))
                const querySnapshot = await getDocs(q)
                querySnapshot.forEach((doc) => {
                    const docData = doc.data()
                    const isUserAdmin = docData.admin
                    const isUserVerified = docData.verified
                    if (isUserAdmin) {
                        setAdminAuthenticated(true)
                    }
                    if (isUserVerified) {
                        setAdminVerified(true)
                    }
                })
                
                setLoading(false)
            }
            else {
                // logged out
                setAuthenticated(false)
                setAdminAuthenticated(false)
                setLoading(false)
            }
        })
        return () => {
            authUnsubscribe()
        }
    }, []);

    const addRoutes = () => {
        const routeList = []
        routeList.push(<Route path='/' element={<Home />} />)
        if (authenticated) {
            routeList.push(<Route path='/tournaments' element={<Tournaments />} />)
            routeList.push(<Route path="/tournaments/detail" element={<TournamentDetailPage />} />)
        }
        else {
            routeList.push(<Route path='/tournaments' element={<LoginSignup />} />)
            routeList.push(<Route path='/login' element={<LoginSignup />} />)
        }
        if (adminAuthenticated) {
            if (adminVerified) {
                routeList.push(<Route path='/admin' element={<AdminPage />} />)
                routeList.push(<Route path='/admin/createTournament' element={<CreateTournament />} />)
                routeList.push(<Route path='/admin/createNewAssociation' element={<CreateNewAssociation />} />)
                routeList.push(<Route path='/admin/createNewCourse' element={<CreateNewGolfCourse />} />)
                routeList.push(<Route path='/admin/listTournaments' element={<ListTournaments />} />)
                routeList.push(<Route path='/admin/editTournament' element={<EditTournament />} />)
                routeList.push(<Route path="/admin/tournamentsByUser" element={<TournamentsByUser />} />)
                routeList.push(<Route path="/admin/tournamentsByUserChallenge" element={<TournamentsByUserWindow />} />)
                routeList.push(<Route path="/admin/listGolfCourses" element={<ListGolfCourses />} />)
                routeList.push(<Route path="/admin/editGolfCourse" element={<EditGolfCourse />} />)
            }
            else {
                routeList.push(routeList.push(<Route path='/admin' element={<AdminUnverifiedPage />} />))
            }
        }
        else {
            routeList.push(<Route path='/admin' element={<AdminLoginSignup />} />)
        }
        return routeList
    }

    if (loading) {
        return (
        <>
            <h1>Loading...</h1>
        </>
        )
    }

    return (
        <Router>
            <Routes>
                { addRoutes() }
            </Routes>
        </Router>
    )
}

export default App;
